import { createContext, useState, useContext, useEffect } from 'react';
import { useUser } from '../context/UserProvider';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const { mongoUser, authStatus } = useUser();
    const [cartItems, setCartItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (authStatus === 'authenticated' && mongoUser) {
            setCartItems(mongoUser.cart || []); // Ensure cart is an array
        } else {
            const localCart = localStorage.getItem('guestCart');
            setCartItems(localCart ? JSON.parse(localCart) : []);
        }
        setLoading(false);
    }, [authStatus, mongoUser]);

    const addToCart = (product) => {
        console.log("addToCart function called with:", product);
        
        if (!product) {
            console.error("Cannot add undefined product to cart");
            return;
        }

        const updatedCart = [...cartItems, { ...product, quantity: 1 }];
        setCartItems(updatedCart);
        console.log("Cart Item Added:", cartItems);

        if (authStatus !== 'authenticated') {
            localStorage.setItem('guestCart', JSON.stringify(updatedCart));
        }
    };

    const removeFromCart = (index) => {
        console.log("🔹 Removing item at index:", index);
    
        if (index === undefined || index < 0 || index >= cartItems.length) {
            console.error("❌ Invalid index:", index);
            return;
        }
    
        setCartItems((prevCartItems) => {
            const updatedCart = prevCartItems.filter((_, i) => i !== index);
    
            // ✅ Update localStorage for guests
            if (authStatus !== 'authenticated') {
                localStorage.setItem("guestCart", JSON.stringify(updatedCart));
            }
    
            console.log("✅ Cart updated after removal:", updatedCart);
            return updatedCart;
        });
    };
    const clearCart = () => {
        setCartItems([]); // Clear cart in state
        localStorage.removeItem("guestCart"); // Clear guest cart if applicable
    };
    

    const updateQuantity = (productId, quantity) => {
        if (!cartItems.some(item => item._id === productId)) return; // Ensure the product exists

        const updatedCart = cartItems.map(item =>
            item._id === productId ? { ...item, quantity } : item
        );

        setCartItems(updatedCart);

        if (authStatus !== 'authenticated') {
            localStorage.setItem('guestCart', JSON.stringify(updatedCart));
        }
    };

    const cartTotal = cartItems.reduce((total, item) => total + (item.price * (item.quantity || 1)), 0);
    const itemCount = cartItems.reduce((count, item) => count + (item.quantity || 1), 0);

    useEffect(() => {
        console.log("Updated Cart Items:", cartItems);
    }, [cartItems]);

    return (
        <CartContext.Provider value={{
            cartItems,
            setCartItems,
            loading,
            addToCart,
            removeFromCart,
            updateQuantity,
            cartTotal,
            itemCount, 
            clearCart
        }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => {
    const context = useContext(CartContext);
    if (!context) {
        throw new Error('useCart must be used within a CartProvider');
    }
    return context;
};

export default CartProvider;
